import styled from 'styled-components';
import { colors, borderRadius, shadows, breakpoints } from '../../styles/theme';

export const GalleryContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem 0 2rem;
`;

export const MainSwiperWrapper = styled.div`
  width: 100%;

  .main-swiper {
    width: 280px;
    height: 380px;
    padding: 20px 0;

    @media (min-width: ${breakpoints.md}) {
      width: 340px;
      height: 440px;
    }
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${borderRadius['2xl']};
    background: ${colors.neutral.white};
    box-shadow: ${shadows.card};
    overflow: hidden;
    border: 1px solid ${colors.neutral.gray200};
  }
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlaceholderSlide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${colors.gradients.card};
  padding: 1.5rem;
  text-align: center;
  color: ${colors.primary.teal};
  gap: 0.75rem;

  svg {
    font-size: 3rem;
    color: ${colors.primary.orange};
  }

  span {
    font-weight: 600;
    font-size: 0.95rem;
  }
`;
